export const icons = ["👨🏻‍💻", "💬", "☕", "🏋️‍♂️", "📚", "⏰"];

export const statuses = {
  "In Progress": {
    icon: "/icons/time_atack_duotone.svg",
    color: "in-progress",
    iconClass: "status-in-progress",
  },
  "Completed": {
    icon: "/icons/done_round_duotone.svg",
    color: "completed",
    iconClass: "status-completed",
  },
  "Will Not Do": {
    icon: "/icons/close_ring_duotone.svg",
    color: "wont-do",
    iconClass: "status-will-not-do",
  },
};
